<script>
export default {
  props: {
    position: {
      type: String,
      default: 'center'
    },
    planType: {
      type: String
    },
    count: {
      type: String,
      default: null
    }
  },
  computed: {
    text () {
      return this.count ? this.count : this.$t(`ramadan.select_plan_label.${this.planType}`)
    }
  }
}
</script>

<template>
  <div class="ramadan-badge" :class="{ 'ramadan-badge_start': position === 'start' }">
    <img src="./assets/ticket-simple.svg" alt="ticket icon" />
    <span class="ramadan-badge__text">
      {{ text }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.ramadan-badge {
  border-radius: 32px;
  background: #ebebff;
  padding-inline: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 28px;
  width: max-content;
  margin-inline: auto;
}

.ramadan-badge_start {
  margin-inline: initial;
}

.ramadan-badge__text {
  display: inline-block;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

@media (max-width: 825px) and (min-width: 679px) {
  .ramadan-badge__text:deep(span) {
    display: none;
  }

  .ramadan-badge:deep(img) {
    display: none;
  }
}
</style>
